import mutations from './mutations';
import appAxios from '@/utility/appAxios';
import { useRouter } from 'vue-router';
import { endpoints } from '@/services/api';

const state = () => ({
  app_detail: {
    title: null,
    version: null,
    draft_version: null,
    review_process_id: null,
    review_process_title: null,
    is_draft: 0,
    active: 0,
  },
});

const getters = {
  app_detail: state => state.app_detail,
  app_title: state => state.title,
};

const actions = {
  async get({ commit }, app_id) {
    const router = useRouter();
    await appAxios.post(endpoints.app_detail, { id: app_id }).then(response => {
      if (response.data.status === true) {
        commit('setAppDetail', response.data.data);
      } else {
        router.push('/');
      }
    });
  },
  setReviewProcess({ commit }, data) {
    commit('setReviewProcess', data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
